/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import { msalApp, GRAPH_ENDPOINTS, GRAPH_REQUESTS } from "Authentication/AuthHelper";

/**
 * Call MsGraph to search AAD User Info.
 * @param {string}  email  the user email.
 */
export async function callMsGraphGetUserByEmail(email: string) {
  const account = msalApp.getAccount();
  if (!account) {
    throw Error(
      "No active account! Verify a user has been signed in and setActiveAccount has been called."
    );
  }

  const response = await msalApp.acquireTokenSilent({
    ...GRAPH_REQUESTS.LOGIN,
    account: account,
  });

  const headers = new Headers();
  const bearer = `Bearer ${response.accessToken}`;

  headers.append("Authorization", bearer);

  const options = {
    method: "GET",
    headers: headers,
  };

  return fetch(`${GRAPH_ENDPOINTS.USER_BY_EMAIL}${email}`, options)
    .then((response) => response.json())
    .catch((error) => error);
}
